class Event {}

export default Event;
